import { create } from 'zustand';

export enum FormMode {
  ADD_TEMPLATE = 'add-template',
  EDIT_TEMPLATE = 'edit-template',
  VIEW_TEMPLATE = 'view-template',
}

type TemplateFormStoreState = {
  currentStep: number;
  isOpen: boolean;
  mode: FormMode;
  reset: () => void;
  setStep: (step: number) => void;
  templateId: null | string;
  toggleAddState: (state: boolean) => void;
  toggleEditState: (payload: { id: string; state: boolean }) => void;
  toggleState: (state: boolean) => void;
  toggleViewState: (payload: { id: string; state: boolean }) => void;
  totalSteps: number;
};

const INITIAL_STATE: Omit<
  TemplateFormStoreState,
  'reset' | 'setStep' | 'toggleAddState' | 'toggleEditState' | 'toggleState' | 'toggleViewState'
> = {
  isOpen: false,
  templateId: null,
  currentStep: 1,
  totalSteps: 4,
  mode: FormMode.ADD_TEMPLATE,
};

export const TemplateFormStore = create<TemplateFormStoreState>()((set) => ({
  ...INITIAL_STATE,

  reset: () => set(INITIAL_STATE),

  toggleState: (state) => {
    set(state ? { isOpen: true } : INITIAL_STATE);
  },

  toggleAddState: (state) => {
    set(state ? { ...INITIAL_STATE, mode: FormMode.ADD_TEMPLATE, isOpen: true } : INITIAL_STATE);
  },

  toggleViewState: ({ id, state }) => {
    set(
      state
        ? { ...INITIAL_STATE, mode: FormMode.VIEW_TEMPLATE, isOpen: true, templateId: id }
        : INITIAL_STATE,
    );
  },

  toggleEditState: ({ id, state }) => {
    set(
      state
        ? { ...INITIAL_STATE, mode: FormMode.EDIT_TEMPLATE, isOpen: true, templateId: id }
        : INITIAL_STATE,
    );
  },

  setStep: (step) => set({ currentStep: step }),
}));
